import React, { useState, useRef, useEffect } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Image from "react-bootstrap/Image";
import Modal from "react-bootstrap/Modal";
import bcrypt from "bcryptjs";
import schoolApi from "../../api/schoolApi";
import Helmet from "react-helmet";
// import AuthContext from "../Auth/AuthProvider";
import jwt_decode from "jwt-decode";
// import { useContext } from "react";
import * as constants from "../../constants/CONSTANT.jsx";
import { useOutletContext } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import authApi from "../../api/authApi.jsx";

const getPUBLICBASEURL = () => {
  const tenantCode = sessionStorage?.getItem("schoolcode") ?? "";
   return `https://crm.idigischool.com/uploads/`;
  //return `http://localhost:3000/uploads/`;
};

const UserProfileEdit = ({ userId }) => {
  console.log("userIdd=>", userId);
  const [selectedStudent, setStudent] = useOutletContext();
  // const { auth, setAuth, accessToken } = useContext(AuthContext);
  const fileInputRef = useRef(null);
  const [imageSrc, setImageSrc] = useState();
  const [studentList, setStudentList] = useState([]);
  const [profile, setProfile] = useState({});
  const [UserInfo, setUserInfo] = useState({});
  const [body, setBody] = useState();
  const [show, setShow] = useState(false);
  const [user, setUser] = useState({ password: "", confirmpassword: "" });
  // const [selectedStudentId, setStudentId] = useState();
  // const [validated, setValidated] = useState(false);

  const [selectedFiles, setSelectedFiles] = useState(null);
  // const [thumbnail, setThumbnail] = useState(null);
  // const [file, setFile] = useState();
  // const [selectedSessionId, setSessionId] = useState();

  useEffect(() => {
    async function init() {
      if (selectedStudent) {
        let studentDetails = await schoolApi.fetchStudentsById(selectedStudent?.id);

        if (sessionStorage.getItem("token") && studentDetails?.success) {
          let user = await jwt_decode(sessionStorage.getItem("token"));

          // console.log('studentDetails-->>' , studentDetails);
          console.log('userInfo-->>' , user);
          
          let imageUrl = null;
          // if (studentDetails?.studentRec.file_parent_id && user.file_parent_id) {
          if (selectedStudent?.file_parent_id && user.userrole === "STUDENT") {
            imageUrl = `${getPUBLICBASEURL()}${selectedStudent?.file_parent_id}/${selectedStudent?.file_id}.${selectedStudent?.filetype}`
            // imageUrl = `${getPUBLICBASEURL()}${studentDetails?.studentRec.file_parent_id}/${studentDetails?.studentRec.file_id}.${studentDetails?.studentRec.filetype}`
          } else {
            imageUrl = `${getPUBLICBASEURL()}dwps_ajmer/image_2024102442318.png`;
          }

          setUserInfo(user);
          setStudentList(studentDetails?.studentRec);
          setImageSrc(imageUrl);
        }
      }
    }
    init();
  }, [selectedStudent]);

  const handlePasswordOnchange = (e) => {
    //console.log(e.target.value)
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleChange = (e) => {
    //console.log('value ki value >>> ', e, "=>", e.target.value)
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  const handlePhotoUpload = async (event) => {
    setBody(URL.createObjectURL(event.target.files[0]));
    console.log(
      "URL.createObjectURL(event.target.files[0]@!@=>",
      URL.createObjectURL(event.target.files[0])
    );
    setSelectedFiles(event.target.files[0]);

    console.log("event.target.files[0]221->", event.target.files[0]);
    if (event.target.files[0] && studentList?.file_id) {
      console.log("Uploading...", event.target.files[0], studentList?.file_id);

      const file = event.target.files[0];
      console.log("fileas=>", file);

      let formData = new FormData();
      formData.append("file", file);

      console.log("formData.entries()@@=>", formData);

      try {
        console.log("formDaat=>", formData);
        // Determine which API call to make
        const resultUploadImage = studentList?.file_parent_id
          ? await schoolApi.saveFiles(studentList?.file_parent_id, formData)
          : await schoolApi.createFile(studentList?.studentid, formData);

        console.log("Uploaded File Response =>", resultUploadImage);

        // Optionally, update the state/UI with the response
        // setSelectedFiles(resultUploadImage);
      } catch (error) {
        console.error("File upload failed:", error);
      }
    }
  };

  const handleClose = () => setShow(false);

  const handleChangepass = async (e) => {
    try {
      console.log("user323323", UserInfo);
      setShow(true);
      e.preventDefault();
    } catch (e) {}
  };

  const handleChangeSubmit = async (e) => {
    try {
      e.preventDefault();
      const match = await bcrypt.compare(user.password, UserInfo.password);

      if (user.password === "") {
        return toast.error("Password is required");
      }
      if (user.password !== user.confirmpassword) {
        return toast.error("Password not matched");
      }
      if (match) {
        return toast.error("Old and New Password are same ");
      }

      const result = await schoolApi.ResetPassword(UserInfo?.email, user.password, UserInfo.tenantcode,UserInfo?.id);

      if (result.success) {
        setShow(false);
        user.confirmpassword = "";
        authApi.logout();
        toast.success("Password updated successfully");
      } else {
        setShow(false);
        toast.error("Password not updated successfully");
      }
    } catch (error) {
      console.log("server-error-->>", error);
    }
  };

  return (
    <>
      <ToastContainer />
      <Helmet>
        <title>User Profile</title>
      </Helmet>
      <Container>
        <div className="div-style">
          <Row>
            <Col lg={1}></Col>
            <Col lg={3}>
              <Card>
                <Card.Body className="text-center">
                  <Card.Title style={{ textAlign: "center" }}>
                    {UserInfo.firstname} {UserInfo.lastname}
                  </Card.Title>
                  <Image
                    variant="top"
                    src={imageSrc}
                    className="rounded-circle user-prfile-image"
                    thumbnail
                    style={{ 
                      width: "200px" ,
                      height: "200px",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                  ></Image>
                  <br />
                  <Button
                    className="btn mt-2"
                    style={{ width: "100%", display: "block" }}
                    variant="danger"
                    onClick={handleChangepass}
                  >
                    Change Password
                  </Button>
                  <input
                    onChange={handlePhotoUpload}
                    name="profilephotourl"
                    accept="image/*"
                    ref={fileInputRef}
                    type="file"
                    hidden
                  />
                </Card.Body>
              </Card>
            </Col>

            <Col style={{ backgroundColor: "#fff" }} lg={7}>
              <Row className="view-form-header align-items-center">
                <Col lg={6}>Edit Profile</Col>
              </Row>

              <Row className="pb-5 py-3">
                <Col lg={6}>
                  <Form.Group className="mx-3 mb-3" controlId="formBasicPhone">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicPhone"
                    >
                      First Name
                    </Form.Label>
                    <Form.Control
                      readOnly
                      type="text"
                      name="firstname"
                      value={UserInfo.firstname}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group
                    className="mx-3 mb-3"
                    controlId="formBasicLastName"
                  >
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicPhone"
                    >
                      Last Name
                    </Form.Label>
                    <Form.Control
                      readOnly
                      type="text"
                      name="lasttname"
                      placeholder="Enter Last Name"
                      value={UserInfo.lastname}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group
                    className="mx-3 mb-3"
                    controlId="formBasicLastEmail"
                  >
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicPhone"
                    >
                      Email
                    </Form.Label>
                    <Form.Control
                      readOnly
                      type="email"
                      name="email"
                      placeholder="Enter Email"
                      value={UserInfo.email}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3 mb-3" controlId="formBasicLastName">
                    <Form.Label className="form-view-label" htmlFor="formBasicPhone">Phone</Form.Label>
                    <Form.Control
                      readOnly
                      type="phone"
                      name="phone"
                      placeholder="Enter Phone"
                      // value={studentList.phone}
                      value={UserInfo.phone}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Col>
            <Col lg={1}></Col>
          </Row>

          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Change Password</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <Form className="mt-3">
                    <Row>
                      <Col>
                        <Form.Group
                          className="mx-3"
                          controlId="formBasicFirstName"
                        >
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicFirstName"
                          >
                            New Password
                          </Form.Label>
                          <Form.Control
                            type="password"
                            name="password"
                            placeholder="Enter Your password"
                            onChange={handlePasswordOnchange}
                            required
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col>
                        <Form.Group className="mx-3" controlId="formBasicPhone">
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicPhone"
                          >
                            Confirm Password
                          </Form.Label>
                          <Form.Control
                            type="password"
                            name="confirmpassword"
                            placeholder="Enter confirm password"
                            onChange={handlePasswordOnchange}
                            required
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Form>
                </Col>
                <Col></Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={handleChangeSubmit}>
                Save
              </Button>
              <Button variant="danger" onClick={handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </Container>
    </>
  );
};

export default UserProfileEdit;
